/**
 * Mock Orders API service for development
 * Simulates orders kanban functionality with realistic data
 */
class MockOrdersApiService {
  constructor() {
    // Status constants - define these first
    this.statuses = {
      PARA_FAZER: "Para fazer",
      AGUARDANDO_MATERIAL: "Aguardando Material",
      FEITO: "Feito",
      AGUARDANDO_TRANSPORTE: "Aguardando Transporte",
      OUTRO: "Outro"
    };

    this.statusConcluido = "Concluído";
    this.statusEmAberto = "Em aberto";

    // Mock product database
    this.mockProducts = [
      { id: "PROD001", name: "Tinta Acrílica Branca 1L", price: 25.90 },
      { id: "PROD002", name: "Pincel Chato 2\"", price: 8.50 },
      { id: "PROD003", name: "Rolo de Pintura", price: 12.00 },
      { id: "PROD004", name: "Fita Crepe 50m", price: 5.80 },
      { id: "PROD005", name: "Lixa 120", price: 2.50 },
      { id: "PROD006", name: "Primer Acrílico 1L", price: 18.90 },
      { id: "PROD007", name: "Tinta Esmalte Azul 1L", price: 32.00 },
      { id: "PROD008", name: "Pincel Redondo 1\"", price: 6.80 },
      { id: "PROD009", name: "Papelão 1m²", price: 3.20 },
      { id: "PROD010", name: "Cola PVA 500ml", price: 15.50 }
    ];

    // Mock clients database - Updated with more diverse names
    this.mockClients = [
      { id: 1, name: "Construtora Silva Ltda", fantasia: "Silva Constr", city: "São Paulo", state: "SP" },
      { id: 2, name: "Restaurante Sabor & Arte", fantasia: "Sabor Arte", city: "Rio de Janeiro", state: "RJ" },
      { id: 3, name: "Escola Futuro Brilhante", fantasia: "Futuro Brilhante", city: "Belo Horizonte", state: "MG" },
      { id: 4, name: "Clínica Saúde Total", fantasia: "Saúde Total", city: "Salvador", state: "BA" },
      { id: 5, name: "Loja Moda Express", fantasia: "Moda Express", city: "Fortaleza", state: "CE" },
      { id: 6, name: "Hotel Vista Mar", fantasia: "Vista Mar", city: "Recife", state: "PE" },
      { id: 7, name: "Farmácia Popular", fantasia: "Farmácia Popular", city: "Porto Alegre", state: "RS" },
      { id: 8, name: "Padaria Pão Quentinho", fantasia: "Pão Quentinho", city: "Curitiba", state: "PR" },
      { id: 9, name: "Academia Corpo Perfeito", fantasia: "Corpo Perfeito", city: "Brasília", state: "DF" },
      { id: 10, name: "Mercado Super Preço", fantasia: "Super Preço", city: "Manaus", state: "AM" },
      { id: 11, name: "Oficina Mecânica Rápida", fantasia: "Mecânica Rápida", city: "Goiânia", state: "GO" },
      { id: 12, name: "Pet Shop Amigo Fiel", fantasia: "Amigo Fiel", city: "Vitória", state: "ES" },
      { id: 13, name: "Barbearia Estilo Clássico", fantasia: "Estilo Clássico", city: "Campo Grande", state: "MS" },
      { id: 14, name: "Lavanderia Express", fantasia: "Lavanderia Express", city: "Cuiabá", state: "MT" },
      { id: 15, name: "Sorveteria Gelato Italiano", fantasia: "Gelato Italiano", city: "Palmas", state: "TO" },
      { id: 16, name: "Loja de Informática Tech", fantasia: "Tech Informática", city: "Aracaju", state: "SE" },
      { id: 17, name: "Floricultura Jardim Encantado", fantasia: "Jardim Encantado", city: "Maceió", state: "AL" },
      { id: 18, name: "Pizzaria Forno a Lenha", fantasia: "Forno a Lenha", city: "João Pessoa", state: "PB" },
      { id: 19, name: "Loja de Esportes Atleta", fantasia: "Atleta Sports", city: "Teresina", state: "PI" },
      { id: 20, name: "Consultório Dentário Sorriso", fantasia: "Sorriso Dental", city: "Natal", state: "RN" },
      { id: 21, name: "Loja de Móveis Casa Linda", fantasia: "Casa Linda", city: "São Luís", state: "MA" },
      { id: 22, name: "Loja de Roupas Fashion", fantasia: "Fashion Store", city: "Belém", state: "PA" },
      { id: 23, name: "Restaurante Churrascaria", fantasia: "Churrascaria", city: "Porto Velho", state: "RO" },
      { id: 24, name: "Loja de Eletrônicos Digital", fantasia: "Digital Eletrônicos", city: "Boa Vista", state: "RR" },
      { id: 25, name: "Loja de Ferramentas Profissional", fantasia: "Ferramentas Pro", city: "Rio Branco", state: "AC" },
      { id: 26, name: "Loja de Brinquedos Alegria", fantasia: "Alegria Brinquedos", city: "Macapá", state: "AP" },
      { id: 27, name: "Loja de Perfumes Aroma", fantasia: "Aroma Perfumes", city: "Florianópolis", state: "SC" },
      { id: 28, name: "Loja de Livros Cultura", fantasia: "Cultura Livros", city: "João Pessoa", state: "PB" },
      { id: 29, name: "Loja de Calçados Pé Conforto", fantasia: "Pé Conforto", city: "Fortaleza", state: "CE" },
      { id: 30, name: "Loja de Bijuterias Brilho", fantasia: "Brilho Bijuterias", city: "Salvador", state: "BA" },
      { id: 31, name: "Loja de Artesanato Arte Nativa", fantasia: "Arte Nativa", city: "Recife", state: "PE" },
      { id: 32, name: "Loja de Instrumentos Musicais", fantasia: "Música & Sons", city: "Belo Horizonte", state: "MG" },
      { id: 33, name: "Loja de Decoração Casa Bela", fantasia: "Casa Bela", city: "São Paulo", state: "SP" },
      { id: 34, name: "Loja de Automóveis Carro Novo", fantasia: "Carro Novo", city: "Rio de Janeiro", state: "RJ" },
      { id: 35, name: "Loja de Bebidas Drinks", fantasia: "Drinks Store", city: "Curitiba", state: "PR" },
      { id: 36, name: "Loja de Cosméticos Beleza", fantasia: "Beleza Cosméticos", city: "Porto Alegre", state: "RS" },
      { id: 37, name: "Loja de Papelaria Escolar", fantasia: "Escolar Papelaria", city: "Brasília", state: "DF" },
      { id: 38, name: "Loja de Relógios Tempo", fantasia: "Tempo Relógios", city: "Manaus", state: "AM" },
      { id: 39, name: "Loja de Óculos Visão", fantasia: "Visão Óculos", city: "Goiânia", state: "GO" },
      { id: 40, name: "Loja de Joias Preciosas", fantasia: "Preciosas Joias", city: "Vitória", state: "ES" }
    ];

    // Generate 40 mock orders - now this.statuses is defined
    this.mockOrders = this.generateMockOrders();
  }

  generateMockOrders() {
    const orders = [];
    const statuses = Object.values(this.statuses);
    
    for (let i = 1; i <= 40; i++) {
      const client = this.mockClients[Math.floor(Math.random() * this.mockClients.length)];
      const status = statuses[Math.floor(Math.random() * statuses.length)];
      const hasReference = Math.random() < 0.7; // 70% chance of having reference
      const hasObs = Math.random() < 0.5; // 50% chance of having observations
      const hasClientObs = Math.random() < 0.3; // 30% chance of having client observations
      
      // Generate 1-5 items per order
      const itemCount = Math.floor(Math.random() * 5) + 1;
      const items = [];
      
      for (let j = 1; j <= itemCount; j++) {
        const product = this.mockProducts[Math.floor(Math.random() * this.mockProducts.length)];
        items.push({
          idPedProduto: (i * 100) + j,
          idProduto: product.id,
          descProduto: product.name,
          qtdeProduto: (Math.floor(Math.random() * 50) + 1).toString()
        });
      }

      // Determine checkbox statuses based on order status
      let statusSeparacao, statusProducao;
      switch (status) {
        case this.statuses.PARA_FAZER:
          statusSeparacao = this.statusEmAberto;
          statusProducao = this.statusEmAberto;
          break;
        case this.statuses.AGUARDANDO_MATERIAL:
          statusSeparacao = this.statusConcluido;
          statusProducao = this.statusEmAberto;
          break;
        case this.statuses.FEITO:
          statusSeparacao = this.statusConcluido;
          statusProducao = this.statusConcluido;
          break;
        case this.statuses.AGUARDANDO_TRANSPORTE:
          statusSeparacao = this.statusConcluido;
          statusProducao = this.statusConcluido;
          break;
        default:
          statusSeparacao = this.statusEmAberto;
          statusProducao = this.statusEmAberto;
      }

      orders.push({
        idPed: i,
        idPedido: `PED${String(i).padStart(3, '0')}`,
        tenantId: `empresa${Math.floor(Math.random() * 3) + 1}`,
        fantasiaCliente: client.fantasia,
        bairroCliente: client.city,
        cidadeCliente: client.city,
        ufCliente: client.state,
        dataPedido: this.generateRandomDate(),
        referenciaPedido: hasReference ? `REF${String(i).padStart(3, '0')}` : '',
        obsPedido: hasObs ? this.generateRandomObservation() : '',
        observacaoCliente: hasClientObs ? this.generateRandomClientObservation() : '',
        statusOperacao: status,
        statusSeparacao: statusSeparacao,
        statusProducao: statusProducao,
        tokenPrioridade: i * 1000,
        itens: items
      });
    }

    return orders;
  }

  generateRandomDate() {
    const end = new Date();
    // Create dates ranging from 30 days ago to today
    // This ensures some orders will be older than 7 days
    const start = new Date(end.getTime() - (30 * 24 * 60 * 60 * 1000));
    const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    return randomDate.toISOString().split('T')[0];
  }

  generateRandomObservation() {
    const observations = [
      'Urgente - Entrega até sexta',
      'Material especial',
      'Pedido grande',
      'Cuidado com o manuseio',
      'Entrega programada',
      'Material frágil',
      'Precisa de embalagem especial',
      'Entrega em horário comercial',
      'Material de alta qualidade',
      'Entrega com agendamento'
    ];
    return observations[Math.floor(Math.random() * observations.length)];
  }

  generateRandomClientObservation() {
    const observations = [
      'Preciso para o final de semana',
      'Cuidado com o manuseio',
      'Entrega programada',
      'Material para obra',
      'Precisa de instalação',
      'Entrega urgente',
      'Material de reposição',
      'Para projeto especial',
      'Entrega com nota fiscal',
      'Material de teste'
    ];
    return observations[Math.floor(Math.random() * observations.length)];
  }

  /**
   * Simulate API delay
   */
  async simulateApiDelay(ms = 300) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Get orders list with pagination and filtering
   */
  async getOrders(limit = 250, offset = 0) {
    await this.simulateApiDelay();
    
    const orders = this.mockOrders.slice(offset, offset + limit);
    
    // Group orders by status
    const ordersByStatus = {
      [this.statuses.PARA_FAZER]: [],
      [this.statuses.AGUARDANDO_MATERIAL]: [],
      [this.statuses.FEITO]: [],
      [this.statuses.AGUARDANDO_TRANSPORTE]: [],
      [this.statuses.OUTRO]: []
    };

    orders.forEach(order => {
      if (ordersByStatus[order.statusOperacao]) {
        ordersByStatus[order.statusOperacao].push(order);
      }
    });

    // Sort orders by priority within each status
    Object.keys(ordersByStatus).forEach(status => {
      ordersByStatus[status].sort((a, b) => a.tokenPrioridade - b.tokenPrioridade);
    });

    return {
      data: orders,
      ordersByStatus,
      total: this.mockOrders.length,
      limit,
      offset
    };
  }

  /**
   * Update order operation status (drag & drop)
   */
  async updateOrderStatus(data) {
    await this.simulateApiDelay();
    
    const order = this.mockOrders.find(o => o.idPed === data.pedidoId);
    if (order) {
      order.statusOperacao = data.status;
      order.tokenPrioridade = data.position;
    }
  }

  /**
   * Update order checkbox status (separacao/producao)
   */
  async updateOrderCheckbox(data) {
    await this.simulateApiDelay();
    
    const order = this.mockOrders.find(o => o.idPed === data.pedidoId);
    if (order) {
      if (data.statusType === 'separacao') {
        order.statusSeparacao = data.isChecked ? this.statusConcluido : this.statusEmAberto;
      } else if (data.statusType === 'producao') {
        order.statusProducao = data.isChecked ? this.statusConcluido : this.statusEmAberto;
      }
    }
  }

  /**
   * Get detailed order information
   */
  async getOrderDetails(pedidoId, tenantId) {
    await this.simulateApiDelay();
    
    const order = this.mockOrders.find(o => o.idPed === pedidoId && o.tenantId === tenantId);
    
    if (!order) {
      throw new Error('Pedido não encontrado');
    }

    // Add mock item updates for testing
    const atualizacoesDeItens = [
      {
        idPedProduto: order.itens[0]?.idPedProduto || 1,
        quantidade: Math.floor(Math.random() * 10) + 1,
        observacao: "Quantidade ajustada"
      }
    ];

    return {
      ...order,
      atualizacoesDeItens
    };
  }

  /**
   * Save order item changes
   */
  async saveOrderChanges(data) {
    await this.simulateApiDelay();
    
    const order = this.mockOrders.find(o => o.idPed === data.pedidoId);
    if (!order) {
      throw new Error('Pedido não encontrado');
    }

    // In a real implementation, this would update the database
    console.log('Saving changes:', data);
  }
}

const mockOrdersApiService = new MockOrdersApiService();
export default mockOrdersApiService;
